/**
 * CustomDataGridDesktop Component
 *
 * Desktop version of the data grid using React Admin's Datagrid.
 * Provides a traditional table layout with sorting and row click support.
 */

import React from 'react';
import { Datagrid, DatagridProps, RaRecord, useResourceDefinition } from 'react-admin';

interface CustomDataGridDesktopProps<RecordType extends RaRecord = any>
  extends DatagridProps<RecordType> {
  children: React.ReactNode;
}

const CustomDataGridDesktop = <RecordType extends RaRecord = any>({
  children,
  expand,
  ...props
}: CustomDataGridDesktopProps<RecordType>) => {
  const { hasShow, hasEdit } = useResourceDefinition();
  const defaultRowClick = hasShow ? 'show' : hasEdit ? 'edit' : false;
  return (
    <Datagrid
      {...props}
      expand={expand}
      bulkActionButtons={false}
      rowClick={expand ? 'expand' : defaultRowClick}
      sx={{
        '& .RaDatagrid-headerCell': {
          fontWeight: 600,
        },
        '& .RaDatagrid-row': {
          cursor: defaultRowClick || expand ? 'pointer' : 'default',
        },
      }}
    >
      {children}
    </Datagrid>
  );
};

export default CustomDataGridDesktop;
